<template>
  <div class="withdraw-detail-container">
    <van-nav-bar :title="$t('Withdrawal details')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="withdraw-info">
        <div class="withdraw-info-left">
          {{ $t("Withdrawal quantity") }}:
          <div class="logo-img">
            <img
              v-if="detailInfo.type.indexOf('USDT') != -1"
              src="../../assets/USDT.png"
              alt=""
            />
            <img
              v-if="detailInfo.type.indexOf('ETH') != -1"
              src="../../assets/ETH.png"
              alt=""
            />
            <img
              v-if="detailInfo.type.indexOf('BTC') != -1"
              src="../../assets/BTC.png"
              alt=""
            />
          </div>
          -{{ detailInfo.money }}{{ detailInfo.type }}
        </div>
        <div class="withdraw-info-right">
          <div
            class="col-bot"
            style="color: #666"
            v-if="detailInfo.status == 1"
          >
            {{ $t("withdrawal_under_review") }}
          </div>
          <div
            class="col-bot"
            style="color: #0062f8"
            v-if="detailInfo.status == 2"
          >
            {{ $t("withdrawal_success") }}
          </div>
          <div class="col-bot" style="color: red" v-if="detailInfo.status == 3">
            {{ $t("fail") }}
          </div>
        </div>
      </div>
      <div class="withdraw-row">
        <div class="withdraw-row-left">Currency</div>
        <div class="withdraw-row-right">
          <div class="logo-img">
            <img
              v-if="detailInfo.type.indexOf('USDT') != -1"
              src="../../assets/USDT.png"
              alt=""
            />
            <img
              v-if="detailInfo.type.indexOf('ETH') != -1"
              src="../../assets/ETH.png"
              alt=""
            />
            <img
              v-if="detailInfo.type.indexOf('BTC') != -1"
              src="../../assets/BTC.png"
              alt=""
            />
          </div>
          {{ detailInfo.type }}
        </div>
      </div>
      <div class="withdraw-row">
        <div class="withdraw-row-left">Status</div>
        <div class="withdraw-row-right">
          <div
            class="col-bot"
            style="color: #666"
            v-if="detailInfo.status == 1"
          >
            {{ $t("withdrawal_under_review") }}
          </div>
          <div
            class="col-bot"
            style="color: #0062f8"
            v-if="detailInfo.status == 2"
          >
            {{ $t("withdrawal_success") }}
          </div>
          <div class="col-bot" style="color: red" v-if="detailInfo.status == 3">
            {{ $t("fail") }}
          </div>
        </div>
      </div>
      <div class="withdraw-col">
        <div class="withdraw-col-top">
          {{ $t("Withdrawal address") }}
        </div>
        <div
          class="withdraw-col-bot"
          v-clipboard:copy="detailInfo.address"
          v-clipboard:success="onCopy"
        >
          <div class="address">
            {{ detailInfo.address }}
          </div>
          <img src="../../assets/recharge-copy.svg" alt="" />
        </div>
      </div>
      <div class="withdraw-col">
        <div class="withdraw-col-top">
          {{ $t("order number") }}
        </div>
        <div
          class="withdraw-col-bot"
          v-clipboard:copy="detailInfo.order_no"
          v-clipboard:success="onCopy"
        >
          <div class="address">
            {{ detailInfo.order_no }}
          </div>
          <img src="../../assets/recharge-copy.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailInfo: "",
    };
  },
  created() {
    this.getWithdrawDetail(this.$route.query.id);
  },
  methods: {
    onCopy() {
      this.$Toast(this.$t("copySuccess"));
    },
    navBack() {
      if (this.$router.history._startLocation.indexOf(this.$route.path) != -1) {
        this.$router.replace("/withdraw-record");
      } else {
        this.$router.go(-1);
      }
    },
    async getWithdrawDetail(id) {
      const res = await this.$api.getWithdrawDetail({ id });
      if (res.code == 200) {
        this.detailInfo = res.data;
      } else {
        this.$Toast(res.message);
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.withdraw-detail-container {
  .back {
    width: 30px;
    height: 15px;
  }
  .content {
    margin-top: 10px;
    padding: 15px;
    background: #fff;
    .withdraw-info {
      width: 100%;
      height: 73px;
      background: url("../../assets/withdraw-bg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      color: #fff;
      font-size: 16px;
      &-left {
        font-weight: 600;
        display: flex;
        align-items: center;
        word-break: keep-all;
        img {
          width: 25px;
          height: 25px;
          margin-right: 15px;
        }
      }
      &-right {
        background: #fff;
        padding: 5px 10px;
        border-radius: 5px;
        margin-left: 20px;
      }
    }
    .withdraw-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 0;
      border-bottom: 1px solid #eee;
      font-size: 14px;
      &-left {
        color: #999;
      }
      &-right {
        display: flex;
        align-items: center;
        .logo-img {
          margin-right: 10px;
          img {
            width: 25px;
            height: 25px;
          }
        }
      }
    }
    .withdraw-col {
      padding: 15px 0;
      border-bottom: 1px solid #eee;
      font-size: 14px;
      &-top {
        color: #999;
      }
      &-bot {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .address {
          flex: 1;
        }
        img {
          width: 20px;
          height: 30px;
        }
      }
    }
  }
}

@media (min-width: 640px) {
  .withdraw-detail-container {
    .back {
      width: 30px;
      height: 15px;
    }
    .content {
      margin-top: 10px;
      padding: 15px;
      background: #fff;
      .withdraw-info {
        width: 100%;
        height: 73px;
        background: url("../../assets/withdraw-bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        box-sizing: border-box;
        color: #fff;
        font-size: 16px;
        &-left {
          font-weight: 600;
          display: flex;
          align-items: center;
          word-break: keep-all;
          img {
            width: 25px;
            height: 25px;
            margin-right: 15px;
          }
        }
        &-right {
          background: #fff;
          padding: 5px 10px;
          border-radius: 5px;
          margin-left: 20px;
        }
      }
      .withdraw-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;
        border-bottom: 1px solid #eee;
        font-size: 14px;
        &-left {
          color: #999;
        }
        &-right {
          display: flex;
          align-items: center;
          .logo-img {
            margin-right: 10px;
            img {
              width: 25px;
              height: 25px;
            }
          }
        }
      }
      .withdraw-col {
        padding: 15px 0;
        border-bottom: 1px solid #eee;
        font-size: 14px;
        &-top {
          color: #999;
        }
        &-bot {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .address {
            flex: 1;
          }
          img {
            width: 20px;
            height: 30px;
          }
        }
      }
    }
  }
}
</style>